/**
 * Business Services layout — page is currently locked with a
 * "Coming Soon" overlay while the core Logistics platform is prioritized.
 */
import { Lock, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const BusinessServicesLayout = ({ children }) => (
  <div className="bg-black text-white min-h-screen relative">
    {/* Underlying page rendered but blurred + non-interactive */}
    <div
      className="pointer-events-none select-none"
      style={{ filter: 'blur(10px) saturate(1.1)', transform: 'scale(1.02)' }}
      aria-hidden="true"
    >
      {children}
    </div>

    {/* Coming Soon lock overlay */}
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/70 backdrop-blur-sm p-6">
      <div className="max-w-xl w-full bg-gradient-to-b from-[#111] to-[#050505] border border-[#D4AF37]/40 shadow-[0_0_80px_rgba(212,175,55,0.25)] p-8 sm:p-12 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 mb-6">
          <Lock className="w-7 h-7 text-[#D4AF37]" />
        </div>
        <div className="text-[#D4AF37] text-[11px] tracking-[0.45em] uppercase font-semibold mb-3">
          Coming Soon
        </div>
        <h1
          style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          className="text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white leading-[0.95]"
        >
          Queen B<br />
          <span className="text-[#D4AF37]">Business Solutions</span>
        </h1>
        <p className="mt-6 text-white/70 text-sm sm:text-base leading-relaxed">
          A new division of Queen B Holdings — premium website design, digital solutions,
          automation, and business infrastructure — is being crafted with the same luxury
          standard as Queen B Logistics.
        </p>
        <p className="mt-4 text-white/50 text-sm">
          We&apos;re focused on perfecting the Logistics experience first. Check back soon.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="group bg-[#D4AF37] text-black px-6 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-[#F5D47B] transition-colors inline-flex items-center gap-2"
            data-testid="bs-coming-soon-return"
          >
            <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
            Return to Logistics
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default BusinessServicesLayout;
